import React, { useEffect, useState, useCallback } from 'react';
import { FaTimes } from 'react-icons/fa';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { useDropzone } from 'react-dropzone';
import { RegisterPaymentIcon, DeleteIcon, SettingsDownloadIcon, PlusIcon, InfoIcon } from 'ui-component/custom-icons/icons';  

// ✅ Clear
const ImagesTab = ({
    productDetails,
    handleFileUpload,
    deleteThumbnail,
    handleSetDefaultThumbnail
}) => {
    const [show, setShow] = useState('');

    const onDrop = useCallback((acceptedFiles) => {
        handleFileUpload(acceptedFiles)
    }, []);
    const handleClose = () => setShow('');

    const handleDelete = () => {
        deleteThumbnail(show);
        setShow('')
    };

    const handleDeleteThumbnail = useCallback((thumbnailId) => {
        setShow(thumbnailId);
    });

    const { getRootProps, getInputProps } = useDropzone({ onDrop });
    return (
        <>
            <div className="form-group ">
                <div className="row mt20">
                    <div className="col-12 "  {...getRootProps()}>

                        {/* <div className="product-container-dragdrop"> */}

                            <input {...getInputProps()} style={{ display: 'none' }} />
                            {/* <div style={{ padding: 'padding: 0px 0px 15px 0px;' }}>
                                <div style={{ marginLeft: '30px', marginBottom: '12px' }}>
                                    <button className="btn btn-default btn-sm drag-drop-btn">Add Images</button>
                                    <span className="drag-drop-text ">or drag them here</span>
                                </div>
                            </div> */}
                            <div className="add-item-empty-div" style={{ alignItems: 'center' }}>
                                <div
                                    className="text-primary"
                                    style={{
                                        marginTop: '1px',
                                        padding: '5px 7px',
                                        border: '2px solid #9e9e9e',
                                        borderRadius: '32px',
                                    }}
                                >
                                    <PlusIcon height="16px" width="16px" />
                                </div>
                                <div style={{ marginLeft: '10px' }}>
                                    <div
                                        className='flex'
                                        style={{
                                            gap: '5px'
                                        }}
                                    >
                                        <span className="fw-500">Drag & Drop or Click to Upload</span>
                                        <span className="text-gray-700">OR</span>
                                        <span className="text-blue-600 fw-500">Browse Files</span>
                                    </div>
                                    <div className="text-gray-600 fw-400 mt-1 flex align-items-center" style={{ fontSize: '10px', gap: '5px' }}>
                                        <InfoIcon width='14px' height='14px' />
                                        <span>
                                            png, jpg, jpeg or webp (Max file size: 5MB)
                                        </span>
                                    </div>
                                </div>
                            </div>
                        {/* </div> */}

                    </div>
                    <div className="col-md-12 mt30">
                        <div className="">
                            <div className="image-upload">
                                {
                                    productDetails?.thumbnails?.map((thumbnail, index) => (

                                        <span className="thumbnail-display">
                                            <img src={thumbnail?.thumbnail_url} style={{ width: '80px' }} alt="product" />
                                            {thumbnail?.is_default == 1 ? (
                                                <button className="thumbnail-btn thumbnail-btn-active">
                                                    <span>Default</span>
                                                </button>
                                            ) : (
                                                <button className="thumbnail-btn" onClick={() => handleSetDefaultThumbnail(thumbnail?.id)}>
                                                    <span>Set as default</span>
                                                </button>
                                            )}
                                            {
                                                thumbnail?.is_default == 0 && (
                                                    <button className="thumbnail-close" onClick={() => handleDeleteThumbnail(thumbnail?.id)}>
                                                        <FaTimes />
                                                    </button>
                                                )
                                            }
                                        </span>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {!!show && <DeleteConfirmation
                show={show}
                handleClose={handleClose}
                handleDelete={handleDelete}
                title="Confirm"
                message={`Are you sure you want to delete ${show?.name}`}
            />}
        </>
    );
};

export default ImagesTab;
